import createCustomStore from '@/utils/create-custom-store';

export default vue => ({
  dataSource: createCustomStore('tracking/api/freight-order-statuses/'),
  valueExpr: 'id',
  displayExpr: it => (it ? vue.$t(it.name) : vue.$t('Not selected')),
});
